import { useButtonGroupContext } from 'components/buttonGroup/ButtonGroupContext';
import { useTabListContext } from 'components/tabList/TabListContext';

// export type MetricSourceType = 'persona' | 'universe' | 'scene' | 'entire';
// export type MetricPeriod = '1d' | '1w' | '1M';

export enum MetricSourceType {
  PERSONA = 'persona',
  UNIVERSE = 'universe',
  SCENE = 'scene',
  ENTIRE = 'entire',
}

export enum MetricPeriod {
  ONE_DAY = '1d',
  ONE_WEEK = '1w',
  ONE_MONTH = '1M',
}

type MetricProps = {
  sourceType: MetricSourceType;
  period: MetricPeriod;
};
export function useRevenueMetricsContext() {
  const { activateButtonItem } = useButtonGroupContext();
  const { activateTabItem } = useTabListContext();

  return {
    sourceType: activateTabItem?.type || MetricSourceType.ENTIRE,
    period: activateButtonItem?.type || MetricPeriod.ONE_DAY,
  } as MetricProps;
}
